import React from 'react';
import LoaderMi from "./LoaderMi";
var SegmentLoader = function (_a) {
    var isLoading = _a.isLoading, taille = _a.taille, children = _a.children;
    return (React.createElement("div", { className: "dsmi-segment-loader" },
        isLoading && React.createElement(LoaderMi, { taille: taille !== null && taille !== void 0 ? taille : "lg" }),
        children));
};
export default SegmentLoader;
